import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import itemConfig from './config/itemConfig';
import setViewTitle from '../../helpers/setViewTitle';
import storagelocationConfig from '../storagelocations/config/storagelocationConfig';
import SimplePage from '../common/SimplePage';
import { Form, Input, FormRow, FormsySelect } from '../common/Forms';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var EditItem = createReactClass({
  getInitialState() {
    return {
      defaultStorageLocationId: null,
      defaultStorageLocationName: null,
    };
  },

  componentWillMount() {
    setViewTitle('Artikel bearbeiten');
  },

  componentDidMount() {
    request.get({
      url: itemConfig.apiUrl + this.props.match.params.itemId,
      success: data => {
        if (this.isMounted()) {
          data.hasBeenFound = true;
          this.setState(data, () => {
            this.form.focusAndSelect('name');
          });
        }
      }
    });
  },

  submitForm(item) {
    request.put({
      url: itemConfig.apiUrl,
      data: item,
      success: () => {
        this.props.history.push(`/items/${this.state.id}`);
      }
    });
  },

  render() {

    return (
      <SimplePage title="Artikel bearbeiten" icon="cubes">
        <Form ref={c => this.form = c}
          onSubmit={this.submitForm}
          isAjaxInProgress={this.props.isAjaxInProgress}
          backButtonLink={`/items/${this.props.match.params.itemId}`}>

          <fieldset>
            <Input name="id" type="hidden" required value={this.state.id} />
            <Input name="defaultStorageLocationId" type="hidden" required value={this.state.defaultStorageLocationId} />

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="name"
                id="name"
                label="Name:"
                type="text"
                value={this.state.name}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <FormsySelect
                layout="vertical"
                name="defaultStorageLocationId"
                id="defaultStorageLocationId"
                label="Standardlager:"
                type="text"
                dataUrl={storagelocationConfig.fastSearchUrl}
                onSelect={this.handleStorageLocationSelect}
                searchPlaceholder="Lagerort auswählen"
                idProp="id"
                displayProp="name"
                inputTooShortText="Geben Sie mind. 2 Zeichen ein"
                noMatchesText="Kein Ergebnis"
                searchInProgressText="Suche..."
                selection={{ id: this.state.defaultStorageLocationId, name: this.state.defaultStorageLocationName}}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="defaultStorageBinName"
                id="defaultStorageBinName"
                label="Lagerplatz:"
                type="text"
                value={this.state.defaultStorageBinName}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="stockUnit"
                id="stockUnit"
                label="Basiseinheit:"
                type="text"
                value={this.state.stockUnit}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="lowStockLimit"
                id="lowStockLimit"
                label="Mindestmenge:"
                type="number"
                value={this.state.lowStockLimit}
                validations="isMoreThan:-1"
                validationErrors={{
                  isMoreThan: 'Die Mindestmenge muss größer 0 sein.',
                }}
                required
              />
            </FormRow>

          </fieldset>
        </Form>
      </SimplePage>
    );
  }
});

export default AjaxInProgressHOC(EditItem);



// WEBPACK FOOTER //
// ./src/components/items/EditItem.js